import { classSerializer } from '@/providers/serializers/class/class';
import { http } from '../http';

export class ClassAPI {

    private static INSTANCE = new ClassAPI();

    public static get instance() {
        return this.INSTANCE;
    }

    private reportsNamespace: string = 'api/reports/v1/class';

    private namespace: string = 'api/nucleus/v2/classes';

    private namspaceV1: string = 'api/nucleus/v1/classes';

    private namespaceV2: string = 'api/ds/users/v2';

    private classNamespace: string = 'api/reports/v1/groups';

    private classNamespaceV1: string = 'api/admin/v1/instructional/coach';

    public fetchClassTimespent(params: any) {
        const endpoint = `${this.reportsNamespace}/user/timespent`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return classSerializer.normalizeClassTimespent(response.data);
        });
    }

    public getTimeSpend(params: any) {
        const endpoint = `${this.namespaceV2}/stats/class/timespent`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, params).then((response) => {
            return classSerializer.normalizeClassTimespentAll(response.data);
        });
    }

    public fetchClassCompetencyReport(params: any) {
        const endpoint = `${this.namespaceV2}/class/user/competency/report`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return classSerializer.normalizeClassCompetencyReport(response.data);
        });
    }

    public fetchLessonStats(params: any) {
        const endpoint = `${this.namespaceV2}/stats/class/lesson`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, params).then((response) => {
            return classSerializer.normalizeClassDashboardReport(response.data);
        });
    }

    public fetchSuggestionStats(params: any) {
        const endpoint = `${this.namespaceV2}/stats/class/suggestions`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, params).then((response) => {
            return classSerializer.normalizeClassDashboardReport(response.data);
        });
    }

    public fetchStreakStats(params: any) {
        const endpoint = `${this.namespaceV2}/stats/class/streakcompetencies`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, params).then((response) => {
            return classSerializer.normalizeClassDashboardReport(response.data);
        });
    }

    public fetchMasteredStats(params: any) {
        const endpoint = `${this.namespaceV2}/stats/class/competency/greaterthan90`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, params).then((response) => {
            return classSerializer.normalizeClassDashboardReport(response.data);
        });
    }

    public fetchUsersClass(userId: string) {
        const endpoint = `${this.classNamespace}/user/classes`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, { userId }).then((response) => {
            return classSerializer.normalizeUserClasses(response.data);
        });
    }

    public fetchInstructionalCoachClass(param: any) {
        const endpoint = `${this.classNamespaceV1}/classes`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, param).then((response) => {
            return response.data;
        });
    }

}

export const classAPI = ClassAPI.instance;
